export function createPhotoUrlWithSize(url: string, size: string) {
  return url.replace('{size}', size)
}

export function jpgToWebp(url: string) {
  return url.replace('.jpg', '.webp').replace('.jpeg', '.webp')
}
